// extracted by mini-css-extract-plugin
export var links = "SocialLinks-module--links--srJF8";